export function getMsg (list, question) {
  let messages = [];
  let contextList = list.filter(item => item.answer !== '' && item.child && item.child.length && item.child[0].status === 'normal')
  console.log('有效的：', contextList)
  if (contextList.length > 0) {
    if (contextList.length === 1) {
      let msg = contextList[0];
      let answer = msg.child && msg.child.length ? msg.child[msg.child.length - 1].answer : msg.answer
      messages.push({
        content: msg.question,
        role: "user",
      });
      messages.push({
        content: answer,
        role: "assistant",
      });
    } else if (contextList.length === 2) {
      let msg = contextList[0];
      let answer = msg.child && msg.child.length ? msg.child[msg.child.length - 1].answer : msg.answer
      messages.push({
        content: msg.question,
        role: "user",
      });
      messages.push({
        content: answer,
        role: "assistant",
      });
      let msg1 = contextList[1];
      let answer1 = msg1.child && msg1.child.length ? msg1.child[msg1.child.length - 1].answer : msg1.answer
      messages.push({
        content: msg1.question,
        role: "user",
      });
      messages.push({
        content: answer1,
        role: "assistant",
      });
    } else if (contextList.length === 3) {
      let msg = contextList[contextList.length - 3];
      let answer = msg.child && msg.child.length ? msg.child[msg.child.length - 1].answer : msg.answer
      messages.push({
        content: msg.question,
        role: "user",
      });
      messages.push({
        content: answer,
        role: "assistant",
      });
      let msg1 = contextList[contextList.length - 2];
      let answer1 = msg1.child && msg1.child.length ? msg1.child[msg1.child.length - 1].answer : msg1.answer
      messages.push({
        content: msg1.question,
        role: "user",
      });
      messages.push({
        content: answer1,
        role: "assistant",
      });
      let msg2 = contextList[contextList.length - 1];
      let answer2 = msg2.child && msg2.child.length ? msg2.child[msg2.child.length - 1].answer : msg2.answer
      messages.push({
        content: msg2.question,
        role: "user",
      });
      messages.push({
        content: answer2,
        role: "assistant",
      });
    } else if (contextList.length === 4) {
      let msg4 = contextList[contextList.length - 4];
      let answer4 = msg4.child && msg4.child.length ? msg4.child[msg4.child.length - 1].answer : msg4.answer
      messages.push({
        content: msg4.question,
        role: "user",
      });
      messages.push({
        content: answer4,
        role: "assistant",
      });
      let msg = contextList[contextList.length - 3];
      let answer = msg.child && msg.child.length ? msg.child[msg.child.length - 1].answer : msg.answer
      messages.push({
        content: msg.question,
        role: "user",
      });
      messages.push({
        content: answer,
        role: "assistant",
      });
      let msg1 = contextList[contextList.length - 2];
      let answer1 = msg1.child && msg1.child.length ? msg1.child[msg1.child.length - 1].answer : msg1.answer
      messages.push({
        content: msg1.question,
        role: "user",
      });
      messages.push({
        content: answer1,
        role: "assistant",
      });
      let msg2 = contextList[contextList.length - 1];
      let answer2 = msg2.child && msg2.child.length ? msg2.child[msg2.child.length - 1].answer : msg2.answer
      messages.push({
        content: msg2.question,
        role: "user",
      });
      messages.push({
        content: answer2,
        role: "assistant",
      });
    } else {
      let msg5 = contextList[contextList.length - 5];
      let answer5 = msg5.child && msg5.child.length ? msg5.child[msg5.child.length - 1].answer : msg5.answer
      messages.push({
        content: msg5.question,
        role: "user",
      });
      messages.push({
        content: answer5,
        role: "assistant",
      });
      let msg4 = contextList[contextList.length - 4];
      let answer4 = msg4.child && msg4.child.length ? msg4.child[msg4.child.length - 1].answer : msg4.answer
      messages.push({
        content: msg4.question,
        role: "user",
      });
      messages.push({
        content: answer4,
        role: "assistant",
      });
      let msg = contextList[contextList.length - 3];
      let answer = msg.child && msg.child.length ? msg.child[msg.child.length - 1].answer : msg.answer
      messages.push({
        content: msg.question,
        role: "user",
      });
      messages.push({
        content: answer,
        role: "assistant",
      });
      let msg1 = contextList[contextList.length - 2];
      let answer1 = msg1.child && msg1.child.length ? msg1.child[msg1.child.length - 1].answer : msg1.answer
      messages.push({
        content: msg1.question,
        role: "user",
      });
      messages.push({
        content: answer1,
        role: "assistant",
      });
      let msg2 = contextList[contextList.length - 1];
      let answer2 = msg2.child && msg2.child.length ? msg2.child[msg2.child.length - 1].answer : msg2.answer
      messages.push({
        content: msg2.question,
        role: "user",
      });
      messages.push({
        content: answer2,
        role: "assistant",
      });
    }
  }
  messages.push({
    content: question,
    role: "user",
  });
  return messages
}



// WEBPACK FOOTER //
// ./src/assets/js/context.js